import { PageHeader } from "~/components/PageHeader";
import { ImageLoader } from "~/components/ImageLoader";
import { RWA_COIN_ICON } from "~/consts";
import { Manager } from "../..";
import { Anchor } from "~/components/Anchor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLink } from "@fortawesome/pro-regular-svg-icons";
import { Badge, BadgeVariants } from "~/components/Badge";
import { addUtmTrackingToUrl } from "~/utils/addUtmTrackingToUrl";
import { AssetManagersUserEvents } from "~/modules/analytics/events/asset_managers";
import { DescriptionDisplay } from "~/components/DescriptionDisplay";

// // // //

/**
 * Header component for manager pages displaying manager info and description
 */
export function ManagerHeader(props: { manager: Manager }) {
    const { manager } = props;

    return (
        <>
            <PageHeader
                title={manager.name}
                icon={
                    <ImageLoader
                        src={manager.icon_url || RWA_COIN_ICON}
                        alt={`${manager.name} Icon`}
                        fallbackSrc={RWA_COIN_ICON}
                        className="h-10 w-10 min-w-10 rounded-full"
                    />
                }
            />

            {manager.website !== null && (
                <div className="flex items-center gap-3 flex-wrap">
                    <Anchor
                        href={addUtmTrackingToUrl(manager.website)}
                        openInNewTab
                        analyticsLabel={
                            AssetManagersUserEvents.ClickManagerIndividualWebsite
                        }
                    >
                        <Badge
                            label={
                                <>
                                    Website
                                    <FontAwesomeIcon
                                        icon={faExternalLink}
                                        className="h-3 ml-1.5"
                                    />
                                </>
                            }
                            variant={BadgeVariants.blue}
                            hover
                            className="px-3 py-0.5"
                            size="sm"
                        />
                    </Anchor>

                    {/* Render badges for Asset Classes? */}
                    {/* {manager.asset_class_stats?.map((ac) => {
                        const { icon, label } = getAssetClassLinkMetadata(
                            ac.id,
                        );
                        return (
                            <Badge
                                variant={BadgeVariants.gray}
                                size="md"
                                rounded="md"
                                label={
                                    <>
                                        <Icon
                                            className="h-2.5 mr-1.5"
                                            icon={icon}
                                        />
                                        {label}
                                    </>
                                }
                            />
                        );
                    })} */}
                </div>
            )}

            <DescriptionDisplay description={manager.description} />
        </>
    );
}
